// Reused unchanged from Mainframe packages/money; see docs/commerce-source-provenance.md.
export function decimalToAtomic(value: string, decimals: number): string {
  if (!/^\d+(?:\.\d+)?$/.test(value) || !Number.isInteger(decimals) || decimals < 0 || decimals > 30) throw new Error("INVALID_DECIMAL_AMOUNT");
  const [whole = "0", fraction = ""] = value.split(".");
  if (fraction.length > decimals && /[1-9]/.test(fraction.slice(decimals))) throw new Error("DECIMAL_PRECISION_LOSS");
  return BigInt(`${whole}${fraction.slice(0, decimals).padEnd(decimals, "0")}`).toString();
}
